/**
 * Better error message utility
 * Converts technical errors to user-friendly messages with actionable suggestions
 */

export const getErrorMessage = (error) => {
  const errorString = error?.message || error?.toString() || 'Unknown error';
  const lowerError = errorString.toLowerCase();

  // Insufficient balance
  if (lowerError.includes('insufficient') && lowerError.includes('balance')) {
    return {
      title: 'Insufficient Balance',
      message: 'You don\'t have enough tokens for this transaction.',
      suggestion: 'Check your balance and try with a smaller amount.'
    };
  }

  // Insufficient gas
  if (lowerError.includes('insufficient') && lowerError.includes('gas')) {
    return {
      title: 'Insufficient Gas',
      message: 'You don\'t have enough BNB to pay for gas fees.',
      suggestion: 'Add more BNB to your wallet to cover transaction costs.'
    };
  }

  // Slippage too low
  if (lowerError.includes('slippage') || lowerError.includes('price') && lowerError.includes('change')) {
    return {
      title: 'Price Changed Too Much',
      message: 'The price moved more than your slippage tolerance.',
      suggestion: 'Increase slippage tolerance to 2-3% in settings.'
    };
  }

  // Transaction reverted
  if (lowerError.includes('revert') || lowerError.includes('execution revert')) {
    return {
      title: 'Transaction Failed',
      message: 'The transaction was rejected by the smart contract.',
      suggestion: 'Check token approval and try again.'
    };
  }

  // User rejected
  if (lowerError.includes('user rejected') || lowerError.includes('user denied')) {
    return {
      title: 'Transaction Cancelled',
      message: 'You cancelled the transaction in your wallet.',
      suggestion: null
    };
  }

  // Network error
  if (lowerError.includes('network') || lowerError.includes('connection')) {
    return {
      title: 'Network Error',
      message: 'Unable to connect to the blockchain network.',
      suggestion: 'Check your internet connection and try again.'
    };
  }

  // No liquidity
  if (lowerError.includes('liquidity') || lowerError.includes('no route')) {
    return {
      title: 'No Liquidity Available',
      message: 'There is not enough liquidity for this token pair.',
      suggestion: 'Try a different token pair or smaller amount.'
    };
  }

  // Default
  return {
    title: 'Transaction Error',
    message: errorString.slice(0, 150),
    suggestion: 'Please try again or contact support if the problem persists.'
  };
};

/**
 * Format error for toast display
 */
export const formatErrorForToast = (error) => {
  const { title, message, suggestion } = getErrorMessage(error);
  const fullMessage = suggestion ? `${message} ${suggestion}` : message;
  return { title, message: fullMessage };
};